@if(this.camsMode != '2' && this.camsMode != '3'){
<div class="page-wrapper">
    <div class="new-container">
        <h1>Activate your F&O segments</h1>
        <div class="text-layout">
            <p [innerHTML]="this.msgString"></p>
        </div>
        @if(!btnLoader){
            <div class="bottom-button-wrapper btn position-relative">
                <div class="safe-secure-wrapper">
                  <img src="https://commondatastorage.googleapis.com/images.5paisa.com/SPOT/Vector.svg" alt="" class="vector-img" />
                  <img src="https://commondatastorage.googleapis.com/images.5paisa.com/SPOT/safesecure.svg" alt="100% safe & secure" class="safe-secure-img" />
                </div>
                <button type="submit" class="btn btn-primary" [disabled]="btnDisable" (click)="getVendorURL() ">
                    Continue
                </button>
              
                <!-- Moved below the button -->
                <div class="upload-manually" (click)="manuallyUpload()">
                    <!-- <b>Fetch Bank Statement {{ dateRange }}</b>  -->
                     Upload Other Income Document Manually
                </div>
              </div>
        }@else {
            <div class="bottom-button-wrapper btn">
                <button class="btn btn-primary">
                    <span class="stage">
                        <span class="dot-pulse"></span>
                    </span>
                </button>
            </div>
        }
        </div>
</div>
}@else {
<div class="page-wrapper">   
    <div class="content-wrapper">
        <div>
         <h1>Activate your F&O segments</h1>
        <!-- <p>Please select one of the below proof type to proceed further.</p> -->
    </div>
    <div class="select-card">
        <app-proof-card  [cardData]="card_data[camsMode == '2'?0:1]" [isSelected]="selectedCardIndex == 1"
    (click)="selectCard(1,card_data[camsMode == '2'?0:1])"></app-proof-card>
        <app-proof-card  [cardData]="card_data[camsMode == '3'?0:1]" [isSelected]="selectedCardIndex == 2"
    (click)="selectCard(2,card_data[camsMode == '3'?0:1])"></app-proof-card>
    </div>
    </div> 
    
   <div class="button-wrapper">
        <button mat-button color="btn" [disabled]="btnDisable" (click)="getVendorURL()">CONTINUE</button>
   </div>
</div>
}